const BedroomIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.52868 3.5286C3.6537 3.40357 3.82327 3.33333 4.00008 3.33333H7.33341V6H3.33341V4C3.33341 3.82319 3.40365 3.65362 3.52868 3.5286ZM4.00008 2H8.00008H12.0001C12.5305 2 13.0392 2.21071 13.4143 2.58579C13.7894 2.96086 14.0001 3.46957 14.0001 4V6.11438C14.2787 6.21289 14.5347 6.37285 14.7476 6.58579C15.1227 6.96086 15.3334 7.46957 15.3334 8V12V13.3333C15.3334 13.7015 15.0349 14 14.6667 14C14.2986 14 14.0001 13.7015 14.0001 13.3333V12.6667H2.00008V13.3333C2.00008 13.7015 1.7016 14 1.33341 14C0.965225 14 0.666748 13.7015 0.666748 13.3333V12V8C0.666748 7.46957 0.877462 6.96086 1.25253 6.58579C1.46547 6.37285 1.72148 6.21289 2.00008 6.11438V4C2.00008 3.46957 2.21079 2.96086 2.58587 2.58579C2.96094 2.21071 3.46965 2 4.00008 2ZM2.00008 11.3333H14.0001V8C14.0001 7.82319 13.9298 7.65362 13.8048 7.5286C13.6798 7.40357 13.5102 7.33333 13.3334 7.33333H8.00008H2.66675C2.48994 7.33333 2.32037 7.40357 2.19534 7.5286C2.07032 7.65362 2.00008 7.82319 2.00008 8V11.3333ZM8.66675 6V3.33333H12.0001C12.1769 3.33333 12.3465 3.40357 12.4715 3.5286C12.5965 3.65362 12.6667 3.82319 12.6667 4V6H8.66675Z"
        fill="#313131"
      />
    </svg>
  );
};

export default BedroomIcon;
